import { render, staticRenderFns } from "./AddNewCapture.vue?vue&type=template&id=a20ac000&"
import script from "./AddNewCapture.vue?vue&type=script&lang=js&"
export * from "./AddNewCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports